import React from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactDatePicker from './ReactDatePicker';
import { DatePickerLayout } from './ReactDayPickerStyles';

dayjs.extend(customParseFormat);

interface DatePickerProps {
  height?: number;
  width?: number;
  id?: string;
  onBlur?: () => void;
  onChange?: (dateString: string) => void;
  value?: string;
  className?: string;
  disabled?: boolean;
}

const DatePicker = ({ height, width, onChange, value, className, ...props }: DatePickerProps) => (
  <DatePickerLayout className={className} width={width} height={height}>
    <ReactDatePicker value={value} onChange={onChange} {...props} />
  </DatePickerLayout>
);
export default DatePicker;
